import request from "@/utils/request";

export default vm => {
  return {
    namespaced: true,
    state: {
      data: {}
    },
    mutations: {
      data: (state, data) => {
        state.data = data;
      }
    },
    actions: {
      handleRequest: (context, playload) => {
        const url = playload.url;
        const method = playload.method;
        const data = playload.data;
        const callback = playload.callback;
        const complete = playload.complete;
        if (method == "GET") {
          request
            .get(url, data)
            .then(response => {
              if (callback) callback(response);
            })
            .catch(error => {
              context.rootGetters["alert"](error);
            });
        } else if (method == "POST") {
          request
            .post(url, data)
            .then(response => {
              if (callback) callback(response);
              if (complete) complete(response);
            })
            .catch(error => {
              context.rootGetters["alert"](error);
              console.log("error: ", error);
            });
        } else if (method == "DELETE") {
          request
            .delete(url, data)
            .then(data => {
              if (callback) callback(data);
            })
            .catch(msg => {
              context.rootGetters["alert"](msg);
            });
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/device.js